import React from "react";
import AppLogo from "../../assets/images/Logo_InstantHelp_IconOnly_white.png";
import { Container } from "../container";
import HeaderToolbar from "./HeaderToolbar";

export const Header: React.FC<{ company?: string }> = ({ company }) => {
  return (
    <Container flexDirection="column" containerClassName="header">
      <Container flexDirection="row" containerClassName="header-banner">
        <img src={AppLogo} alt="logo" />
        <h1 className="title">InstantHelp</h1>
        {company && (
          <>
            <div className="header-divider" />
            <h1 className="title">{company}</h1>
          </>
        )}
      </Container>
      <HeaderToolbar />
    </Container>
  );
};
export default Header;
